// src/app/features/admin/store/admin.actions.ts

import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserListItem, UserDetail, Branch, UserListFilter } from '../models/admin.model';

export const AdminUsersActions = createActionGroup({
  source: 'Admin/Users',
  events: {
    'Load':    props<{ filter?: UserListFilter; forceReload?: boolean }>(),
    'Success': props<{ data: UserListItem[]; filter?: UserListFilter }>(),
    'Failure': props<{ error: string }>(),
    'Clear':   emptyProps(),
  },
});

export const AdminBranchesActions = createActionGroup({
  source: 'Admin/Branches',
  events: {
    'Load':    props<{ forceReload?: boolean }>(),
    'Success': props<{ data: Branch[] }>(),
    'Failure': props<{ error: string }>(),
  },
});

export const AdminUserDetailActions = createActionGroup({
  source: 'Admin/UserDetail',
  events: {
    'Load':    props<{ userId: number; forceReload?: boolean }>(),
    'Success': props<{ userId: number; data: UserDetail }>(),
    'Failure': props<{ userId: number; error: string }>(),
    'Clear':   props<{ userId: number }>(),
  },
});

/** Optimistic patch — update single user in the list after a mutation */
export const AdminUserPatchActions = createActionGroup({
  source: 'Admin/UserPatch',
  events: {
    'Patch 2FA':    props<{ userId: number; twoFactorEnabled: boolean; twoFactorMode: number; email_2FA: string; twoFactorConfirmed: boolean }>(),
    'Patch Active': props<{ userId: number; active: boolean }>(),
  },
});
